import { render, staticRenderFns } from "./TableLogDetail.vue?vue&type=template&id=9b493992&scoped=true&lang=pug"
import script from "./TableLogDetail.vue?vue&type=script&lang=js"
export * from "./TableLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b493992",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b493992')) {
      api.createRecord('9b493992', component.options)
    } else {
      api.reload('9b493992', component.options)
    }
    module.hot.accept("./TableLogDetail.vue?vue&type=template&id=9b493992&scoped=true&lang=pug", function () {
      api.rerender('9b493992', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableLogDetail.vue"
export default component.exports